import axios from 'axios';
import * as BalmUI from './balm-ui';
import install from './install';

export const useHTTP = () => axios;

export default install(axios, BalmUI);
